module.exports = __webpack_public_path__ + "0599bdb9a5d104c2d924dba2d849d2b0.png";